import { render, staticRenderFns } from "./IndexMobile.vue?vue&type=template&id=0848b34c&"
import script from "./IndexMobile.vue?vue&type=script&lang=ts&"
export * from "./IndexMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports